module.exports = __webpack_public_path__ + "assets/img/20_159.9393e4c3.jpg";